import api from '@/api'

const store = {
  state: {
    dataItem: [],
    pagingItem: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingItem: {
      byField: '',
      isDesc: false
    },
    filteringItem: {
      itemCode: null,
      itemDescription: null
    }
  },

  mutations: {
    SET_ITEM: (state, payload) => {
      state.dataItem = payload
    },
    SET_PAGING_PAGE_ITEM: (state, payload) => {
      state.pagingItem.page = payload
    },
    SET_PAGING_TOTAL_ITEM: (state, payload) => {
      state.pagingItem.total = payload
    },
    SET_SORTING_ITEM: (state, payload) => {
      state.sortingItem = payload
    },
    SET_FILTERING_ITEM: (state, payload) => {
      state.filteringItem = payload
    }
  },

  getters: {
    SortingItem: state => state.sortingItem,
    FilteringItem: state => state.filteringItem,
    PagingItem: state => state.pagingItem,
    GetAllItem: state => state.dataItem,
    GetOneItem: state => id =>
      state.dataItem.find(dataItem => dataItem.id === id)
  },

  actions: {
    async UpdateSortingItem({ commit, dispatch }, payload) {
      commit('SET_SORTING_ITEM', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllItem')
    },

    async UpdateFilteringItem({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_ITEM', emptyFilter)
      }
      commit('SET_PAGING_PAGE_ITEM', 1)
      dispatch('GetAllItem')
    },

    async GetAllItem({ commit, state }) {
      try {
        const result = await api.GetAllItem(
          state.pagingItem,
          state.sortingItem,
          state.filteringItem
        )
        commit('SET_PAGING_TOTAL_ITEM', result.headers['data-length'])
        commit('SET_ITEM', result.data.data)
        return result.data
      } catch (e) {
        throw e
      }
    },

    async CreateItem({ dispatch }, payload) {
      try {
        const { data } = await api.CreateItem(payload)
        dispatch('GetAllItem')
        return data
      } catch (e) {
        throw e
      }
    },

    async UpdateItem({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateItem(payload.id, payload)
        dispatch('GetAllItem')
        return data
      } catch (e) {
        throw e
      }
    },

    async DeleteItem({ dispatch }, id) {
      try {
        const { data } = await api.DeleteItem(id)
        dispatch('GetAllItem')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
